<script lang="ts">
export default {
    name: 'ProductListPanel',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import ProductListPanelSearch from '@/components/app/product/list/panel/search.vue';
import ProductListPanelWorkspace from '@/components/app/product/list/panel/workspace.vue';

defineProps<{
    noSearch?: boolean;
    noWorkspace?: boolean;
}>();

const QUERY_SEARCH = 'search';
const QUERY_WORKSPACE = 'workspace';

const route = useRoute();
const router = useRouter();

function getQueryValues(value: string | (string | null)[] | undefined): string[] {
    const values = Array.isArray(value) ? value : [value];

    return values.filter((item): item is string => typeof item === 'string' && item.length > 0);
}

function updateQuery(name: string, values: string[]) {
    const normalizedValues = [...new Set(values)];
    const currentValues = getQueryValues(route.query[name]);

    if (normalizedValues.length === currentValues.length
        && normalizedValues.every((value, index) => value === currentValues[index])
    ) return;

    const query = {
        ...route.query,
        [name]: normalizedValues.length ? normalizedValues : undefined,
    };

    router.replace({ query });
}

const search = computed({
    get: () => getQueryValues(route.query[QUERY_SEARCH])[0],
    set: value => updateQuery(QUERY_SEARCH, value ? [value] : []),
});

const workspaceIds = computed<(string | number)[]>({
    get: () => getQueryValues(route.query[QUERY_WORKSPACE]),
    set: value => updateQuery(QUERY_WORKSPACE, value.map(String)),
});
</script>

<template>
    <div
        v-if="!noSearch || !noWorkspace"
        class="flex items-center justify-start gap-x-3"
    >
        <product-list-panel-search
            v-if="!noSearch"
            v-model="search"
            class="w-56"
        />
        <product-list-panel-workspace
            v-if="!noWorkspace"
            v-model="workspaceIds"
        />
    </div>
</template>
